// src/utils/cartUtils.js

export const calculateTotalPrice = (price, quantity) => price * quantity;